/**
 * The Environmental, Social & Governance teaser on the Ryerson Commitment landing page
 * (`src/pages/why-ryerson/ryerson-commitment/index.tsx`, its only importer), linking to the ESG
 * page. It has no layout of its own: it renders the Certification & Compliance teaser layouts
 * (`../CertificationAndCompliance/CertificateAndComplianceDesktop.tsx` and
 * `CertificateAndComplianceMobile.tsx`), with separate desktop and mobile copy from
 * `./Content.tsx`.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import { ESGContentDesktop, ESGContentMobile } from "./Content";
import CertificateAndComplianceMobile from "../CertificationAndCompliance/CertificateAndComplianceMobile";
import CertificateAndComplianceDesktop from "../CertificationAndCompliance/CertificateAndComplianceDesktop";
import { useApplication } from "@ryerson/frontend.application";

/** `ContentSection` background type; one of several identical copies in `RyersonCommitment/`. */
export type backgroundType = "primary" | "secondary";

/**
 * Same shape as `../CertificationAndCompliance/CertificateAndCompliance.tsx` →
 * `CertificateAndComplianceProps`, which documents the fields; the content is spread straight
 * into those layouts.
 */
export interface ESGProps {
	background?: backgroundType;
	title: string;
	content: string;
	imageUrl: string;
	buttonLabel: string;
	moreAboutLink: string;
}

/** Renders the ESG teaser in the visitor's language, mobile below `lg`. */
const ESG: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	return (
		<>
			<Media lessThan="lg">
				<CertificateAndComplianceMobile {...ESGContentMobile[language]} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<CertificateAndComplianceDesktop {...ESGContentDesktop[language]} />
			</Media>
		</>
	);
};

export default ESG;
